import styled from "styled-components";

export const TopbarContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  box-sizing: border-box;
`;

export const TopbarFloatingWrapper = styled.div`
  height: 3.8rem;
  width: 100%;
`;
